package com.fireavert.events.dismiss_event.client.presentation

class DismissEventDialogController(private val interactor: DismissEvent) {
    fun onLoad(eventId: Long) = interactor.dismissEvent(eventId)
    fun close(propertyId: Int) = interactor.close(propertyId)
}